// minified version
function getFocusableElements(e) {
    return Array.from(e.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}
document.querySelectorAll('[id^="Details-"] summary').forEach((e) => {
    e.setAttribute("role", "button"),
        e.setAttribute("aria-expanded", e.parentNode.hasAttribute("open")),
        e.nextElementSibling.getAttribute("id") && e.setAttribute("aria-controls", e.nextElementSibling.id),
        e.addEventListener("click", (e) => {
            e.currentTarget.setAttribute("aria-expanded", !e.currentTarget.closest("details").hasAttribute("open"));
        }),
        e.closest("header-drawer") || e.parentElement.addEventListener("keyup", onKeyUpEscape);
});
const trapFocusHandlers = {};
function trapFocus(e, t = e) {
    var i = getFocusableElements(e),
        s = i[0],
        r = i[i.length - 1];
    removeTrapFocus(),
        (trapFocusHandlers.focusin = (t) => {
            (t.target === e || t.target === r || t.target === s) && document.addEventListener("keydown", trapFocusHandlers.keydown);
        }),
        (trapFocusHandlers.focusout = function () {
            document.removeEventListener("keydown", trapFocusHandlers.keydown);
        }),
        (trapFocusHandlers.keydown = function (t) {
            "TAB" === t.code.toUpperCase() && (t.target !== r || t.shiftKey || (t.preventDefault(), s.focus()), (t.target === e || t.target === s) && t.shiftKey && (t.preventDefault(), r.focus()));
        }),
        document.addEventListener("focusout", trapFocusHandlers.focusout),
        document.addEventListener("focusin", trapFocusHandlers.focusin),
        t.focus();
}
try {
    document.querySelector(":focus-visible");
} catch (e) {
    focusVisiblePolyfill();
}
function focusVisiblePolyfill() {
    let e = ["ARROWUP", "ARROWDOWN", "ARROWLEFT", "ARROWRIGHT", "TAB", "ENTER", "SPACE", "ESCAPE", "HOME", "END", "PAGEUP", "PAGEDOWN"],
        t = null,
        i = null;
    window.addEventListener("keydown", (t) => {
        e.includes(t.code.toUpperCase()) && (i = !1);
    }),
        window.addEventListener("mousedown", (e) => {
            i = !0;
        }),
        window.addEventListener(
            "focus",
            () => {
                t && t.classList.remove("focused"), i || (t = document.activeElement).classList.add("focused");
            },
            !0
        );
}
function pauseAllMedia() {
    document.querySelectorAll(".js-youtube").forEach((e) => {
        e.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
    }),
        document.querySelectorAll(".js-vimeo").forEach((e) => {
            e.contentWindow.postMessage('{"method":"pause"}', "*");
        }),
        document.querySelectorAll("video").forEach((e) => e.pause()),
        document.querySelectorAll("product-model").forEach((e) => {
            e.modelViewerUI && e.modelViewerUI.pause();
        });
}
function removeTrapFocus(e = null) {
    document.removeEventListener("focusin", trapFocusHandlers.focusin), document.removeEventListener("focusout", trapFocusHandlers.focusout), document.removeEventListener("keydown", trapFocusHandlers.keydown), e && e.focus();
}
function onKeyUpEscape(e) {
    if ("ESCAPE" !== e.code.toUpperCase()) return;
    let t = e.target.closest("details[open]");
    if (!t) return;
    let i = t.querySelector("summary");
    t.removeAttribute("open"), i.setAttribute("aria-expanded", !1), i.focus();
}
class QuantityInput extends HTMLElement {
    constructor() {
        super(), (this.input = this.querySelector("input")), (this.changeEvent = new Event("change", { bubbles: !0 })), this.querySelectorAll("button").forEach((e) => e.addEventListener("click", this.onButtonClick.bind(this)));
    }
    onButtonClick(e) {
        e.preventDefault();
        let t = this.input.value;
        "plus" === e.target.name ? this.input.stepUp() : this.input.stepDown(), t !== this.input.value && this.input.dispatchEvent(this.changeEvent);
    }
}
function debounce(e, t) {
    let i;
    return (...s) => {
        clearTimeout(i), (i = setTimeout(() => e.apply(this, s), t));
    };
}
function fetchConfig(e = "json") {
    return { method: "POST", headers: { "Content-Type": "application/json", Accept: `application/${e}` } };
}
customElements.define("quantity-input", QuantityInput),
    void 0 === window.Shopify && (window.Shopify = {}),
    (Shopify.bind = function (e, t) {
        return function () {
            return e.apply(t, arguments);
        };
    }),
    (Shopify.setSelectorByValue = function (e, t) {
        for (var i = 0, s = e.options.length; i < s; i++) {
            var r = e.options[i];
            if (t == r.value || t == r.innerHTML) return (e.selectedIndex = i), i;
        }
    }),
    (Shopify.addListener = function (e, t, i) {
        e.addEventListener ? e.addEventListener(t, i, !1) : e.attachEvent("on" + t, i);
    }),
    (Shopify.postLink = function (e, t) {
        var i = (t = t || {}).method || "post",
            s = t.parameters || {},
            r = document.createElement("form");
        for (var n in (r.setAttribute("method", i), r.setAttribute("action", e), s)) {
            var o = document.createElement("input");
            o.setAttribute("type", "hidden"), o.setAttribute("name", n), o.setAttribute("value", s[n]), r.appendChild(o);
        }
        document.body.appendChild(r), r.submit(), document.body.removeChild(r);
    }),
    (Shopify.CountryProvinceSelector = function (e, t, i) {
        (this.countryEl = document.getElementById(e)),
            (this.provinceEl = document.getElementById(t)),
            (this.provinceContainer = document.getElementById(i.hideElement || t)),
            Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this)),
            this.initCountry(),
            this.initProvince();
    }),
    (Shopify.CountryProvinceSelector.prototype = {
        initCountry: function () {
            var e = this.countryEl.getAttribute("data-default");
            Shopify.setSelectorByValue(this.countryEl, e), this.countryHandler();
        },
        initProvince: function () {
            var e = this.provinceEl.getAttribute("data-default");
            e && this.provinceEl.options.length > 0 && Shopify.setSelectorByValue(this.provinceEl, e);
        },
        countryHandler: function (e) {
            var t = this.countryEl.options[this.countryEl.selectedIndex],
                i = JSON.parse(t.getAttribute("data-provinces"));
            if ((this.clearOptions(this.provinceEl), i && 0 == i.length)) this.provinceContainer.style.display = "none";
            else {
                for (var s = 0; s < i.length; s++) {
                    var t = document.createElement("option");
                    (t.value = i[s][0]), (t.innerHTML = i[s][1]), this.provinceEl.appendChild(t);
                }
                this.provinceContainer.style.display = "";
            }
        },
        clearOptions: function (e) {
            for (; e.firstChild; ) e.removeChild(e.firstChild);
        },
        setOptions: function (e, t) {
            for (var i = 0; i < t.length; i++) {
                var s = document.createElement("option");
                (s.value = t[i]), (s.innerHTML = t[i]), e.appendChild(s);
            }
            t.length;
        },
    });
class MenuDrawer extends HTMLElement {
    constructor() {
        super(), (this.mainDetailsToggle = this.querySelector("details")), this.addEventListener("keyup", this.onKeyUp.bind(this)), this.addEventListener("focusout", this.onFocusOut.bind(this)), this.bindEvents();
    }
    bindEvents() {
        this.querySelectorAll("summary").forEach((e) => e.addEventListener("click", this.onSummaryClick.bind(this))), this.querySelectorAll("button").forEach((e) => e.addEventListener("click", this.onCloseButtonClick.bind(this)));
    }
    onKeyUp(e) {
        if ("ESCAPE" !== e.code.toUpperCase()) return;
        let t = e.target.closest("details[open]");
        t && (t === this.mainDetailsToggle ? this.closeMenuDrawer(e, this.mainDetailsToggle.querySelector("summary")) : this.closeSubmenu(t));
    }
    onSummaryClick(e) {
        let t = e.currentTarget,
            i = t.parentNode,
            s = i.closest(".has-submenu"),
            r = i.hasAttribute("open"),
            n = window.matchMedia("(prefers-reduced-motion: reduce)");
        function o() {
            trapFocus(t.nextElementSibling, i.querySelector("button")), t.nextElementSibling.removeEventListener("transitionend", o);
        }
        i === this.mainDetailsToggle
            ? (r && e.preventDefault(), r ? this.closeMenuDrawer(e, t) : this.openMenuDrawer(t), window.matchMedia("(max-width: 990px)") && document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`))
            : setTimeout(() => {
                  i.classList.add("menu-opening"), t.setAttribute("aria-expanded", !0), s && s.classList.add("submenu-open"), !n || n.matches ? o() : t.nextElementSibling.addEventListener("transitionend", o);
              }, 100);
    }
    openMenuDrawer(e) {
        setTimeout(() => {
            this.mainDetailsToggle.classList.add("menu-opening");
        }),
            e.setAttribute("aria-expanded", !0),
            trapFocus(this.mainDetailsToggle, e),
            document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }
    closeMenuDrawer(e, t = !1) {
        void 0 !== e &&
            (this.mainDetailsToggle.classList.remove("menu-opening"),
            this.mainDetailsToggle.querySelectorAll("details").forEach((e) => {
                e.removeAttribute("open"), e.classList.remove("menu-opening");
            }),
            this.mainDetailsToggle.querySelectorAll(".submenu-open").forEach((e) => {
                e.classList.remove("submenu-open");
            }),
            document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`),
            removeTrapFocus(t),
            this.closeAnimation(this.mainDetailsToggle));
    }
    onFocusOut(e) {
        setTimeout(() => {
            this.mainDetailsToggle.hasAttribute("open") && !this.mainDetailsToggle.contains(document.activeElement) && this.closeMenuDrawer();
        });
    }
    onCloseButtonClick(e) {
        let t = e.currentTarget.closest("details");
        this.closeSubmenu(t);
    }
    closeSubmenu(e) {
        let t = e.closest(".submenu-open");
        t && t.classList.remove("submenu-open"), e.classList.remove("menu-opening"), e.querySelector("summary").setAttribute("aria-expanded", !1), removeTrapFocus(e.querySelector("summary")), this.closeAnimation(e);
    }
    closeAnimation(e) {
        let t,
            i = (s) => {
                void 0 === t && (t = s);
                let r = s - t;
                r < 400 ? window.requestAnimationFrame(i) : (e.removeAttribute("open"), e.closest("details[open]") && trapFocus(e.closest("details[open]"), e.querySelector("summary")));
            };
        window.requestAnimationFrame(i);
    }
}
customElements.define("menu-drawer", MenuDrawer);
class HeaderDrawer extends MenuDrawer {
    constructor() {
        super();
    }
    openMenuDrawer(e) {
        (this.header = this.header || document.getElementById("shopify-section-header")),
            (this.borderOffset = this.borderOffset || this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom") ? 1 : 0),
            document.documentElement.style.setProperty("--header-bottom-position", `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`),
            this.header.classList.add("menu-open"),
            setTimeout(() => {
                this.mainDetailsToggle.classList.add("menu-opening");
            }),
            e.setAttribute("aria-expanded", !0),
            trapFocus(this.mainDetailsToggle, e),
            document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }
    closeMenuDrawer(e, t) {
        super.closeMenuDrawer(e, t), this.header.classList.remove("menu-open");
    }
}
customElements.define("header-drawer", HeaderDrawer);
class ModalDialog extends HTMLElement {
    constructor() {
        super(),
            this.querySelector('[id^="ModalClose-"]').addEventListener("click", this.hide.bind(this, !1)),
            this.addEventListener("keyup", (e) => {
                "ESCAPE" === e.code.toUpperCase() && this.hide();
            }),
            this.classList.contains("media-modal")
                ? this.addEventListener("pointerup", (e) => {
                      "mouse" !== e.pointerType || e.target.closest("deferred-media, product-model") || this.hide();
                  })
                : this.addEventListener("click", (e) => {
                      e.target === this && this.hide();
                  });
    }
    connectedCallback() {
        this.moved || ((this.moved = !0), document.body.appendChild(this));
    }
    show(e) {
        this.openedBy = e;
        let t = this.querySelector(".template-popup");
        document.body.classList.add("overflow-hidden"), this.setAttribute("open", ""), t && t.loadContent(), trapFocus(this, this.querySelector('[role="dialog"]')), window.pauseAllMedia();
    }
    hide() {
        document.body.classList.remove("overflow-hidden"), document.body.dispatchEvent(new CustomEvent("modalClosed")), this.removeAttribute("open"), removeTrapFocus(this.openedBy), window.pauseAllMedia();
    }
}
customElements.define("modal-dialog", ModalDialog);
class ModalOpener extends HTMLElement {
    constructor() {
        super();
        let e = this.querySelector("button");
        if (!e) return;
        e.addEventListener("click", () => {
            let t = document.querySelector(this.getAttribute("data-modal"));
            t && t.show(e);
        });
    }
}
customElements.define("modal-opener", ModalOpener);
class DeferredMedia extends HTMLElement {
    constructor() {
        super();
        let e = this.querySelector('[id^="Deferred-Poster-"]');
        if (!e) return;
        e.addEventListener("click", this.loadContent.bind(this));
    }
    loadContent(e = !0) {
        if ((window.pauseAllMedia(), !this.getAttribute("loaded"))) {
            let t = document.createElement("div");
            t.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(!0)), this.setAttribute("loaded", !0);
            let i = this.appendChild(t.querySelector("video, model-viewer, iframe"));
            e && i.focus();
        }
    }
}
customElements.define("deferred-media", DeferredMedia);
class SliderComponent extends HTMLElement {
    constructor() {
        if (
            (super(),
            (this.slider = this.querySelector('[id^="Slider-"]')),
            (this.sliderItems = this.querySelectorAll('[id^="Slide-"]')),
            (this.enableSliderLooping = !1),
            (this.currentPageElement = this.querySelector(".slider-counter--current")),
            (this.pageTotalElement = this.querySelector(".slider-counter--total")),
            (this.prevButton = this.querySelector('button[name="previous"]')),
            (this.nextButton = this.querySelector('button[name="next"]')),
            !this.slider || !this.nextButton)
        )
            return;
        this.initPages();
        let e = new ResizeObserver((e) => this.initPages());
        e.observe(this.slider),
            this.slider.addEventListener("scroll", this.update.bind(this)),
            this.prevButton.addEventListener("click", this.onButtonClick.bind(this)),
            this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
    }
    initPages() {
        (this.sliderItemsToShow = Array.from(this.sliderItems).filter((e) => e.clientWidth > 0)),
            this.sliderItemsToShow.length < 2 ||
                ((this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft),
                (this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset)),
                (this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1),
                this.update());
    }
    resetPages() {
        (this.sliderItems = this.querySelectorAll('[id^="Slide-"]')), this.initPages();
    }
    update() {
        let e = this.currentPage;
        (this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1),
            this.currentPageElement && this.pageTotalElement && ((this.currentPageElement.textContent = this.currentPage), (this.pageTotalElement.textContent = this.totalPages)),
            this.currentPage != e && this.dispatchEvent(new CustomEvent("slideChanged", { detail: { currentPage: this.currentPage, currentElement: this.sliderItemsToShow[this.currentPage - 1] } })),
            this.enableSliderLooping ||
                (this.isSlideVisible(this.sliderItemsToShow[0]) && 0 === this.slider.scrollLeft ? this.prevButton.setAttribute("disabled", "disabled") : this.prevButton.removeAttribute("disabled"),
                this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1]) ? this.nextButton.setAttribute("disabled", "disabled") : this.nextButton.removeAttribute("disabled"));
    }
    isSlideVisible(e, t = 0) {
        let i = this.slider.clientWidth + this.slider.scrollLeft - t;
        return e.offsetLeft + e.clientWidth <= i && e.offsetLeft >= this.slider.scrollLeft;
    }
    onButtonClick(e) {
        e.preventDefault();
        let t = e.currentTarget.dataset.step || 1;
        (this.slideScrollPosition = "next" === e.currentTarget.name ? this.slider.scrollLeft + t * this.sliderItemOffset : this.slider.scrollLeft - t * this.sliderItemOffset), this.slider.scrollTo({ left: this.slideScrollPosition });
    }
}
customElements.define("slider-component", SliderComponent);
class SlideshowComponent extends SliderComponent {
    constructor() {
        if ((super(), (this.sliderControlWrapper = this.querySelector(".slider-buttons")), (this.enableSliderLooping = !0), !this.sliderControlWrapper)) return;
        (this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide")),
            this.sliderItemsToShow.length > 0 && (this.currentPage = 1),
            (this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll(".slider-counter__link"))),
            this.sliderControlLinksArray.forEach((e) => e.addEventListener("click", this.linkToSlide.bind(this))),
            this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this)),
            this.setSlideVisibility(),
            "true" === this.slider.getAttribute("data-autoplay") && this.setAutoPlay();
    }
    setAutoPlay() {
        (this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay")),
            (this.autoplaySpeed = 1e3 * this.slider.dataset.speed),
            this.sliderAutoplayButton.addEventListener("click", this.autoPlayToggle.bind(this)),
            this.addEventListener("mouseover", this.focusInHandling.bind(this)),
            this.addEventListener("mouseleave", this.focusOutHandling.bind(this)),
            this.addEventListener("focusin", this.focusInHandling.bind(this)),
            this.addEventListener("focusout", this.focusOutHandling.bind(this)),
            this.play(),
            (this.autoplayButtonIsSetToPlay = !0);
    }
    onButtonClick(e) {
        super.onButtonClick(e);
        let t = 1 === this.currentPage,
            i = this.currentPage === this.sliderItemsToShow.length;
        (t || i) &&
            (t && "previous" === e.currentTarget.name
                ? (this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length)
                : i && "next" === e.currentTarget.name && (this.slideScrollPosition = 0),
            this.slider.scrollTo({ left: this.slideScrollPosition }));
    }
    update() {
        super.update(),
            (this.sliderControlButtons = this.querySelectorAll(".slider-counter__link")),
            this.prevButton.removeAttribute("disabled"),
            this.sliderControlButtons.length &&
                (this.sliderControlButtons.forEach((e) => {
                    e.classList.remove("slider-counter__link--active"), e.removeAttribute("aria-current");
                }),
                this.sliderControlButtons[this.currentPage - 1].classList.add("slider-counter__link--active"),
                this.sliderControlButtons[this.currentPage - 1].setAttribute("aria-current", !0));
    }
    autoPlayToggle() {
        this.togglePlayButtonState(this.autoplayButtonIsSetToPlay), this.autoplayButtonIsSetToPlay ? this.pause() : this.play(), (this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay);
    }
    focusOutHandling(e) {
        let t = e.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(e.target);
        this.autoplayButtonIsSetToPlay && !t && this.play();
    }
    focusInHandling(e) {
        let t = e.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(e.target);
        t && this.autoplayButtonIsSetToPlay ? this.play() : this.autoplayButtonIsSetToPlay && this.pause();
    }
    play() {
        this.slider.setAttribute("aria-live", "off"), clearInterval(this.autoplay), (this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed));
    }
    pause() {
        this.slider.setAttribute("aria-live", "polite"), clearInterval(this.autoplay);
    }
    togglePlayButtonState(e) {
        e
            ? (this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused"), this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.playSlideshow))
            : (this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused"), this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.pauseSlideshow));
    }
    autoRotateSlides() {
        let e = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector(".slideshow__slide").clientWidth;
        this.slider.scrollTo({ left: e });
    }
    setSlideVisibility() {
        this.sliderItemsToShow.forEach((e, t) => {
            let i = e.querySelectorAll("a");
            t === this.currentPage - 1
                ? (i.length &&
                      i.forEach((e) => {
                          e.removeAttribute("tabindex");
                      }),
                  e.setAttribute("aria-hidden", "false"),
                  e.removeAttribute("tabindex"))
                : (i.length &&
                      i.forEach((e) => {
                          e.setAttribute("tabindex", "-1");
                      }),
                  e.setAttribute("aria-hidden", "true"),
                  e.setAttribute("tabindex", "-1"));
        });
    }
    linkToSlide(e) {
        e.preventDefault();
        let t = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(e.currentTarget) + 1 - this.currentPage);
        this.slider.scrollTo({ left: t });
    }
}
customElements.define("slideshow-component", SlideshowComponent);
class VariantSelects extends HTMLElement {
    constructor() {
        super(), this.addEventListener("change", this.onVariantChange);
    }
    onVariantChange() {
        this.updateOptions(),
            this.updateMasterId(),
            this.toggleAddButton(!0, "", !1),
            this.updatePickupAvailability(),
            this.removeErrorMessage(),
            this.currentVariant ? (this.updateMedia(), this.updateURL(), this.updateVariantInput(), this.renderProductInfo(), this.updateShareUrl()) : (this.toggleAddButton(!0, "", !0), this.setUnavailable());
    }
    updateOptions() {
        this.options = Array.from(this.querySelectorAll("select"), (e) => e.value);
    }
    updateMasterId() {
        this.currentVariant = this.getVariantData().find((e) => !e.options.map((e, t) => this.options[t] === e).includes(!1));
    }
    updateMedia() {
        if (!this.currentVariant || !this.currentVariant.featured_media) return;
        let e = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
        e.forEach((e) => e.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, !0));
        let t = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
        if (!t) return;
        let i = t.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
        t.prepend(i);
    }
    updateURL() {
        this.currentVariant && "false" !== this.dataset.updateUrl && window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
    updateShareUrl() {
        let e = document.getElementById(`Share-${this.dataset.section}`);
        e && e.updateUrl && e.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
    updateVariantInput() {
        let e = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
        e.forEach((e) => {
            let t = e.querySelector('input[name="id"]');
            (t.value = this.currentVariant.id), t.dispatchEvent(new Event("change", { bubbles: !0 }));
        });
    }
    updatePickupAvailability() {
        let e = document.querySelector("pickup-availability");
        e && (this.currentVariant && this.currentVariant.available ? e.fetchAvailability(this.currentVariant.id) : (e.removeAttribute("available"), (e.innerHTML = "")));
    }
    removeErrorMessage() {
        let e = this.closest("section");
        if (!e) return;
        let t = e.querySelector("product-form");
        t && t.handleErrorMessage();
    }
    renderProductInfo() {
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
            .then((e) => e.text())
            .then((e) => {
                let t = new DOMParser().parseFromString(e, "text/html"),
                    i = document.getElementById(`price-${this.dataset.section}`),
                    s = t.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
                s && i && (i.innerHTML = s.innerHTML);
                let r = document.getElementById(`price-${this.dataset.section}`);
                r && r.classList.remove("visibility-hidden"), this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
            });
    }
    toggleAddButton(e = !0, t, i = !0) {
        let s = document.getElementById(`product-form-${this.dataset.section}`);
        if (!s) return;
        let r = s.querySelector('[name="add"]'),
            n = s.querySelector('[name="add"] > span');
        if (r && (e ? (r.setAttribute("disabled", "disabled"), t && (n.textContent = t)) : (r.removeAttribute("disabled"), (n.textContent = window.variantStrings.addToCart)), !i)) return;
    }
    setUnavailable() {
        let e = document.getElementById(`product-form-${this.dataset.section}`),
            t = e.querySelector('[name="add"]'),
            i = e.querySelector('[name="add"] > span'),
            s = document.getElementById(`price-${this.dataset.section}`);
        t && ((i.textContent = window.variantStrings.unavailable), s && s.classList.add("visibility-hidden"));
    }
    getVariantData() {
        return (this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent)), this.variantData;
    }
}
customElements.define("variant-selects", VariantSelects);
class VariantRadios extends VariantSelects {
    constructor() {
        super();
    }
    updateOptions() {
        let e = Array.from(this.querySelectorAll("fieldset"));
        this.options = e.map((e) => Array.from(e.querySelectorAll("input")).find((e) => e.checked).value);
    }
}
customElements.define("variant-radios", VariantRadios);
class ProductRecommendations extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        let e = (e, t) => {
            e[0].isIntersecting &&
                (t.unobserve(this),
                fetch(this.dataset.url)
                    .then((e) => e.text())
                    .then((e) => {
                        let t = document.createElement("div");
                        t.innerHTML = e;
                        let i = t.querySelector("product-recommendations");
                        i && i.innerHTML.trim().length && (this.innerHTML = i.innerHTML),
                            !this.querySelector("slideshow-component") && this.classList.contains("complementary-products") && this.remove(),
                            t.querySelector(".grid__item") && this.classList.add("product-recommendations--loaded"),
                            setTimeout(function () {
                                $(".sc-nl-coll-prod").slick({
                                    prevArrow:
                                        '<button class="slick-prev prev-arrow-hero" aria-label="Previous" type="button"><svg width="66" height="68" viewBox="0 0 66 68" fill="none" xmlns="http://www.w3.org/2000/svg"><ellipse cx="33" cy="34" rx="32" ry="33" fill="white" stroke="black" stroke-width="1.5" fill-opacity="0"></ellipse><path d="M35.8404 23.161C36.4272 23.7637 36.4272 24.7409 35.8404 25.3436L27.8861 33.5123L35.8404 41.6809C36.4272 42.2836 36.4272 43.2608 35.8404 43.8635C35.2535 44.4662 34.3019 44.4662 33.715 43.8635L24.6981 34.6035C24.1112 34.0008 24.1112 33.0237 24.6981 32.421L33.715 23.161C34.3019 22.5583 35.2535 22.5583 35.8404 23.161Z" stroke="black" stroke-width="3" fill="black"></path></svg></button>',
                                    nextArrow:
                                        '<button class="slick-next next-arrow-hero" aria-label="Next" type="button"><svg width="66" height="68" viewBox="0 0 66 68" fill="none" xmlns="http://www.w3.org/2000/svg"><ellipse cx="33" cy="34" rx="32" ry="33" fill="white" stroke="black" stroke-width="1.5" fill-opacity="0"/><path d="M30.0442 23.161C29.4573 23.7637 29.4573 24.7409 30.0442 25.3436L37.9984 33.5123L30.0442 41.6809C29.4573 42.2836 29.4573 43.2608 30.0442 43.8635C30.6311 44.4662 31.5826 44.4662 32.1695 43.8635L41.1864 34.6035C41.7733 34.0008 41.7733 33.0237 41.1864 32.421L32.1695 23.161C31.5826 22.5583 30.6311 22.5583 30.0442 23.161Z" stroke="black" stroke-width="3" fill="black"/></svg></button>',
                                    dots: !1,
                                    autoplay: !1,
                                    slidesToShow: 4,
                                    responsive: [
                                        { breakpoint: 767, settings: { slidesToShow: 2, arrows: !0 } },
                                        { breakpoint: 991, settings: { slidesToShow: 2 } },
                                        { breakpoint: 1199, settings: { slidesToShow: 4 } },
                                    ],
                                });
                            }, 500);
                    })
                    .catch((e) => {
                        console.error(e);
                    }));
        };
        new IntersectionObserver(e.bind(this), { rootMargin: "0px 0px 400px 0px" }).observe(this);
    }
}
customElements.define("product-recommendations", ProductRecommendations);
